import type { Money } from "@getaways/core";

const LOCALE = "en-GB";

/** Local times are shown as written, never converted. */
export function localTime(local: string): string {
  return local.slice(11, 16);
}

export function localDate(local: string): string {
  const d = new Date(`${local.slice(0, 10)}T00:00:00Z`);
  return d.toLocaleDateString(LOCALE, { weekday: "short", day: "numeric", month: "short", year: "numeric", timeZone: "UTC" });
}

/** A Money in its currency's own decimals (JPY has none, KWD three). */
export function amount(m: Money | undefined): string {
  if (!m) return "—";
  const fmt = new Intl.NumberFormat(LOCALE, { style: "currency", currency: m.currency });
  return fmt.format(m.amountMinor / 10 ** (fmt.resolvedOptions().maximumFractionDigits ?? 2));
}

/** Several billing currencies have no common total: "€80.00 + CHF 12.00". */
export const amounts = (list: Money[]) => (list.length ? list.map(amount).join(" + ") : "—");

/** "in 12 min", "3 h ago". */
export function relative(iso: string, now = Date.now()): string {
  const mins = Math.round((Date.parse(iso) - now) / 60_000);
  const abs = Math.abs(mins);
  const text = abs < 60 ? `${abs} min` : abs < 48 * 60 ? `${Math.round(abs / 60)} h` : `${Math.round(abs / 1440)} days`;
  return mins >= 0 ? `in ${text}` : `${text} ago`;
}
